import Vue from 'vue';
export default {

  /* 
   * 将cityNo 转 cityName
   * cityData:原数据
   * cityNo：二级地区编码
   */
  formatLocation(longitude, latitude) {
    if (typeof longitude === 'string' && typeof latitude === 'string') {
      longitude = parseFloat(longitude)
      latitude = parseFloat(latitude)
    }

    longitude = longitude.toFixed(2)
    latitude = latitude.toFixed(2)

    return {
      longitude: longitude.toString().split('.'),
      latitude: latitude.toString().split('.')
    }
  },
  getCityName(cityData, cityNo) {
    if (!cityNo) return;
    if (!(cityData instanceof Array)) return;
    // 9112
    cityNo += "";
    for (let i = 0; i < cityData.length; i++) {
      let sheng = cityData[i];
      for (let j = 0; j < sheng.children.length; j++) {
        let shi = sheng.children[j];
        if (shi.value == cityNo) {
          // 使用return 终止循环
          return `${sheng.label}-${shi.label}`;
        }
      }
    }
  },

  /* 
   * obj 转 params字符串参数  
   * 例子：{a:1,b:2} => a=1&b=2
   */
  objParseParam(obj) {
    let paramsStr = "";
    if (obj instanceof Array) return paramsStr;
    if (!(obj instanceof Object)) return paramsStr;
    for (let key in obj) {
      paramsStr += `${key}=${obj[key]}&`;
    }
    return paramsStr.substring(0, paramsStr.length - 1);
  },
  like(listData) {
    const that = this;
    if (localStorage.likes) {
      const likes = JSON.parse(localStorage.likes);
      let defaultIndex = likes.findIndex((value, index, arr) => {
        return value.id === listData.id
      });
      if (defaultIndex >= 0) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  },
  likeTouch(listData) {
    const that = this;
    if (localStorage.likes) {
      const likes = JSON.parse(localStorage.likes);
      let defaultIndex = likes.findIndex((value, index, arr) => {
        return value.id === listData.id
      });
      if (defaultIndex >= 0) {
        likes.splice(defaultIndex, 1);
        localStorage.likes = JSON.stringify(likes);
        return false;
      } else {
        likes.push({
          id: listData.id,
          title: listData.title,
          site: listData.site,
          end_date: listData.end_date
        });
        localStorage.likes = JSON.stringify(likes);
        return true;
      }
    } else {
      const likes = [];
      likes.push({
        id: listData.id,
        title: listData.title,
        site: listData.site,
        end_date: listData.end_date
      });
      localStorage.likes = JSON.stringify(likes);
      return true;
    }
  },
  /* 
   * obj 转 路由地址带参数
   * 例子：{a:1,b:2} => /pages/index/index?a=1&b=2
   */
  objParseUrlAndParam(path, obj) {
    let url = path || "/";
    let paramsStr = "";
    if (obj instanceof Array) return url;
    if (!(obj instanceof Object)) return url;
    paramsStr = this.objParseParam(obj);
    paramsStr && (url += "?");
    url += paramsStr;
    return url;
  },

  /* 
   * 获取url字符串参数
   */
  getRequestParameters(locationhref) {
    let href = locationhref || "";
    let theRequest = new Object();
    let str = href.split("?")[1];
    if (str != undefined) {
      let strs = str.split("&");
      for (let i = 0; i < strs.length; i++) {
        theRequest[strs[i].split("=")[0]] = (strs[i].split("=")[1]);
      }
    }
    return theRequest;
  },

  /* 
   * 银行卡每四位空格
   */
  formatCardNo(cardNo) {
    cardNo += "";
    return cardNo.replace(/\s/g, '').replace(/[^\d]/g, '').replace(/(\d{4})(?=\d)/g, '$1 ');
  },

  /**
   * 乘法，解决js精度损失问题
   * @param {*} arg1 
   * @param {*} arg2 
   */
  accMul(arg1, arg2) {
    arg1 = arg1 || 0;
    var m = 0,
      s1 = arg1.toString(),
      s2 = arg2.toString();
    try {
      m += s1.split(".")[1].length
    } catch (e) {}
    try {
      m += s2.split(".")[1].length
    } catch (e) {}
    return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m)
  },
  // 判断是否是微信浏览器
  is_weixin() {
    var ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      return true;
    } else {
      return false;
    }
  },

  timeFormat(date) {
    let newDate = /\d{4}-\d{1,2}-\d{1,2}/g.exec(date)
    console.log(newDate)
    return newDate[0]
  },

  format(dataTime) {
    function add(m) {
      return m < 10 ? '0' + m : m
    }
    let time = new Date(dataTime.replace(/-/g, "/"))
    let y = time.getFullYear();
    let m = time.getMonth() + 1;
    let d = time.getDate();
    let h = time.getHours();
    let mm = time.getMinutes();
    let s = time.getSeconds();
    return `${y}年${add(m)}月${add(d)}日`;
  },
  debounce(fn, delay) {

    var delay = delay || 200;
    var timer;
    return function () {
      var th = this;
      var args = arguments;
      if (timer) {
        clearTimeout(timer);
      }
      timer = setTimeout(function () {
        timer = null;
        fn.apply(th, args);
      }, delay);
    }
  },

}